import { render, staticRenderFns } from "./positionRefAdd.vue?vue&type=template&id=b9dd9a5a&"
import script from "./positionRefAdd.vue?vue&type=script&lang=js&"
export * from "./positionRefAdd.vue?vue&type=script&lang=js&"
import style0 from "./positionRefAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports